import { api } from "@/api/client"
import { GameNotificationsResponse } from "../types/gameNotification"
import { guardiansLogApiError } from "../utils/guardiansDebugLog"
import { getGameApiErrorMessage } from "./gameApiErrors"
import { normalizeGameNotificationsResponse } from "../utils/gameNotificationsNormalize"

/** GET /game/notifications — inbox «Хранители» (без Booking / Радар / оплаты). */
export async function getGameNotifications(): Promise<GameNotificationsResponse> {
  try {
    const { data } = await api.get<unknown>("/game/notifications")
    return normalizeGameNotificationsResponse(data)
  } catch (error) {
    guardiansLogApiError("GET /game/notifications", error)
    throw new Error(
      getGameApiErrorMessage(error, "Не удалось загрузить уведомления")
    )
  }
}

/** PATCH /notification — отметить прочитанным. */
export async function markGameNotificationRead(
  notificationId: number
): Promise<void> {
  try {
    await api.patch("/notification", {
      notification_id: notificationId,
      isReaded: true,
    })
  } catch (error) {
    guardiansLogApiError("PATCH /notification", error)
    throw new Error(
      getGameApiErrorMessage(error, "Не удалось отметить уведомление")
    )
  }
}

/** DELETE /notification/by-user — убрать уведомление у текущего игрока. */
export async function deleteGameNotification(
  notificationId: number
): Promise<void> {
  try {
    await api.delete("/notification/by-user", {
      data: { notification_id: notificationId },
    })
  } catch (error) {
    guardiansLogApiError("DELETE /notification/by-user", error)
    throw new Error(
      getGameApiErrorMessage(error, "Не удалось удалить уведомление")
    )
  }
}
